/**
 * Generates a random point between a lower and upper bound (inclusive).
 * @param lower lower bound
 * @param upper upper bound
 */
function generateRand(lower: number, upper: number): number {
    return Math.trunc((Math.random() * (1+upper-lower))) + lower;
}

/**
 * Generates a random coordinate within the provided bounds.
 * @param left left bound (x)
 * @param right right bound (x)
 * @param down lower bound (y)
 * @param up upper bound (y)
 * @param minDepth mininum depth (z)
 * @param maxDepth maximum depth (z)
 */
export function generateCoord(left: number, right: number,
                              down: number, up: number,
                              minDepth: number, maxDepth: number): Array<number> {
    let x = generateRand(left, right);
    let y = generateRand(down, up);

    //note: both are negative, so parameters are reversed
    let z = generateRand(maxDepth, minDepth);
    return [x, y, z];
}

/**
 * Randomly picks a color from a list of colors.
 * @param colors a list of colors
 */
export function getColor(colors: Array<string>): string {
    return colors[Math.trunc(Math.random() * colors.length)];
}